import React, { useEffect, useState } from "react";

import {
    Box,
    Button,
    Card,
    CardContent,
    Checkbox,
    CircularProgress,
    FormControl,
    Grid,
    MenuItem,
    Paper,
    Select,
    Snackbar,
    Alert,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

import DealerActivationService from "../../services/DealerActivationService";

const DealerActivationCommand = () => {
    const [rows, setRows] = useState([]);

    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(0);

    const [pageSize, setPageSize] = useState(50);

    const [totalCount, setTotalCount] = useState(0);

    const [search, setSearch] = useState("");

    const [selectedRows, setSelectedRows] = useState([]);

    const [period, setPeriod] = useState("1_year");

    const [snackbar, setSnackbar] = useState({
        open: false,
        severity: "success",
        message: "",
    });

    const getList = async () => {

        setLoading(true);

        try {

            const payload = {

                page: page + 1,

                page_size: pageSize,

                search,
            };

            const res =
                await DealerActivationService.getDealerActivationList(payload);

            setRows(res.data.results || []);

            setTotalCount(res.data.count || 0);

        } catch (err) {

            setSnackbar({

                open: true,

                severity: "error",

                message: "Unable to load data",

            });

        }

        setLoading(false);
    };

    useEffect(() => {

        getList();

    }, [page, pageSize]);

    const handleSearch = () => {

        setPage(0);

        getList();

    };

    const handleReset = () => {

        setSearch("");

        setPage(0);

        getList();

    };

    const handleSelect = (id) => {

        if (selectedRows.includes(id)) {

            setSelectedRows(selectedRows.filter((x) => x !== id));

        } else {

            setSelectedRows([...selectedRows, id]);

        }

    };

    const handleSelectAll = (e) => {

        if (e.target.checked) {

            setSelectedRows(rows.map((item) => item.id));

        } else {

            setSelectedRows([]);

        }

    };

    const handleSendCommand = async () => {

        if (selectedRows.length === 0) {

            setSnackbar({

                open: true,

                severity: "warning",

                message: "Please select one or more rows",

            });

            return;

        }

        try {

            setLoading(true);

            const payload = {

                device_stock_ids: selectedRows,

                period,

            };

            const res =
                await DealerActivationService.sendDealerActivationCommand(payload);

            setSnackbar({

                open: true,

                severity: "success",

                message:
                    res.data.message ||
                    "Activation command sent successfully",

            });

            setSelectedRows([]);

            getList();

        } catch (err) {

            setSnackbar({

                open: true,

                severity: "error",

                message:
                    err.response?.data?.message ||
                    "Activation failed",

            });

        }

        setLoading(false);

    };

    return (

        <Box>

            <Card>

                <CardContent>

                    <Typography
                        variant="h6"
                        fontWeight={700}
                        mb={2}
                    >

                        Dispatched stock awaiting activation ({totalCount} total)

                    </Typography>

                    <Grid container spacing={2} mb={2}>

                        <Grid item xs={12} md={5}>

                            <TextField

                                fullWidth

                                placeholder="Search imei / iccid / esn / msisdn"

                                value={search}

                                onChange={(e) => setSearch(e.target.value)}

                            />

                        </Grid>

                        <Grid item>

                            <Button

                                variant="contained"

                                startIcon={<SearchIcon />}

                                onClick={handleSearch}

                            >

                                Search

                            </Button>

                        </Grid>

                        <Grid item>

                            <Button

                                variant="outlined"

                                startIcon={<RestartAltIcon />}

                                onClick={handleReset}

                            >

                                Reset

                            </Button>

                        </Grid>

                    </Grid>

                    <TableContainer component={Paper}>

                        <Table>

                            <TableHead>

                                <TableRow>

                                    <TableCell padding="checkbox">

                                        <Checkbox

                                            checked={
                                                rows.length > 0 &&
                                                selectedRows.length === rows.length
                                            }

                                            onChange={handleSelectAll}

                                        />

                                    </TableCell>

                                    <TableCell>ID</TableCell>

                                    <TableCell>IMEI</TableCell>

                                    <TableCell>ICCID</TableCell>

                                    <TableCell>DEVICE ESN</TableCell>

                                    <TableCell>MSISDN</TableCell>

                                    <TableCell>STATUS</TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {

                                    loading ?

                                        <TableRow>

                                            <TableCell
                                                colSpan={7}
                                                align="center"
                                            >

                                                <CircularProgress />

                                            </TableCell>

                                        </TableRow>

                                        :

                                        rows.length === 0 ?

                                            <TableRow>

                                                <TableCell
                                                    colSpan={7}
                                                    align="center"
                                                >

                                                    No Data Available

                                                </TableCell>

                                            </TableRow>

                                            :

                                            rows.map((row) => (

                                                <TableRow key={row.id} hover>

                                                    <TableCell padding="checkbox">

                                                        <Checkbox

                                                            checked={selectedRows.includes(row.id)}

                                                            onChange={() => handleSelect(row.id)}

                                                        />

                                                    </TableCell>

                                                    <TableCell>{row.id}</TableCell>

                                                    <TableCell>{row.imei}</TableCell>

                                                    <TableCell>{row.iccid}</TableCell>

                                                    <TableCell>{row.device_esn}</TableCell>

                                                    <TableCell>{row.msisdn1}</TableCell>

                                                    <TableCell>{row.stock_status}</TableCell>

                                                </TableRow>

                                            ))

                                }

                            </TableBody>

                        </Table>

                    </TableContainer>

                    <TablePagination

                        component="div"

                        count={totalCount}

                        page={page}

                        rowsPerPage={pageSize}

                        onPageChange={(e, newPage) => setPage(newPage)}

                        rowsPerPageOptions={[10, 25, 50, 100]}

                        onRowsPerPageChange={(e) => {

                            setPageSize(parseInt(e.target.value));

                            setPage(0);

                        }}

                    />

                </CardContent>

            </Card>

            <Box mt={3}>

                <Card>

                    <CardContent>

                        <Typography
                            variant="h6"
                            fontWeight={700}
                            mb={2}
                        >

                            Send activation command

                        </Typography>

                        <Grid container spacing={2} alignItems="center">

                            <Grid item>

                                <FormControl sx={{ minWidth: 250 }}>

                                    <Select

                                        value={period}

                                        onChange={(e) => setPeriod(e.target.value)}

                                    >

                                        <MenuItem value="1_year">

                                            1 Year

                                        </MenuItem>

                                        <MenuItem value="2_year_plus_10_days">

                                            2 Years + 10 Days

                                        </MenuItem>

                                    </Select>

                                </FormControl>

                            </Grid>

                            <Grid item>

                                <Button

                                    variant="contained"

                                    size="large"

                                    onClick={handleSendCommand}

                                    disabled={loading}

                                >

                                    Send Activation Command

                                </Button>

                            </Grid>

                        </Grid>

                    </CardContent>

                </Card>

            </Box>

            <Snackbar

                open={snackbar.open}

                autoHideDuration={4000}

                anchorOrigin={{

                    vertical: "top",

                    horizontal: "right"

                }}

                onClose={() => setSnackbar({ ...snackbar, open: false })}

            >

                <Alert

                    severity={snackbar.severity}

                    variant="filled"

                >

                    {snackbar.message}

                </Alert>

            </Snackbar>

        </Box>

    );

}

export default DealerActivationCommand;